import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { Device } from '@ionic-native/device';
import {Validators, FormBuilder, FormGroup } from '@angular/forms';
//import {OrderHistoryPage} from '../orderhistory/orderhistory';
import { LoadingController } from 'ionic-angular';
import {HomePage} from '../home/home';
import { Platform} from 'ionic-angular';
import { AlertController } from 'ionic-angular';
//import { Paytm } from '@ionic-paytm/paytm';
import { Paytm } from '@ionic-native/paytm';
import {MyvariableService} from '../home/constantvariable';

@Component({
	selector: 'page-payment',
	templateUrl: 'payment.html',
    providers:[MydataService,MyUrlService,JsonData,Device,Platform,Paytm,MyvariableService]
})
export class PaymentPage implements OnInit {
	jsonDt : Array<JsonData>;
	addtocartDt: Array<JsonData>;
	res : Array<JsonData>;
	totalAmountDt:string;
	noofitem :string;
	checkvalue:boolean;
	private data : FormGroup;
	payMethod:string;
	sendTotalAmount:any;
	sendContinueData:any;
	sendDiscount :any;
	sendTaxableamt :any;
	sendSGSTtaxamt :any;
	CGSTtaxamt : any;
	sendBillamt :any;
	sendGSTAmt : any;
	checkSum:any;
	startPayment:any;
	deliveryGST:any;
	deliveryCharge:any;
	totalBillamt:any;
	chargTaxDt:any;
	takeawayDiscount:any;
	referFriendPoint:any;
	signupPoint:any;
	minOrderValue:string;
	showDiscount:any;
	cashondelivery:any;
	sendJsonData:any;
	typeofCalling:string;
	totalAmount =this.totalAmount = window.localStorage.getItem('totalAmount');
	useddiscount = this.useddiscount=window.localStorage.getItem('useddiscount');
	
	constructor(private MyvariableService: MyvariableService,private paytm: Paytm,private platform: Platform,public navCtrl: NavController,public alerCtrl: AlertController,public loading: LoadingController,private formBuilder: FormBuilder,public device: Device,private http:Http,private mydataService: MydataService,private myurlService: MyUrlService) {
		
		this.data = this.formBuilder.group({
			langs: ['', Validators.required]
		});
		
	}
	/*
		paytm.action(){
		cordova.exec(
        successResultHandler,
        errorResultHandler,
		"PayTM",
		"startPayment",
		["25", "155", "deep@gmail.com", "7777777777", "25600"]);	
		} 
		exports.module=paytm;
	*/
	ngOnInit() {
		
		/*	this.platform.ready().then(() => {
			StatusBar.styleDefault();
			startPayment=function();
			});
		*/	
		this.showDiscount='1';
		//	window.plugins.paytm.startPayment("526", "25862", "abc@gmail.com", "777777777", "25", successCallback, failureCallback);
		//		alert(givenpoint);
		if(this.mydataService.checkInternetFunction()=="0"){
			////console.log("Internet UnAvailable")
			}else  if(this.mydataService.checkInternetFunction()=="1"){
			var userid = window.localStorage.getItem('userid');
			//alert(userid);
			var kiloSabjiJSONdata = JSON.stringify({"userid":userid});
			//console.log("Home Url--->"+this.myurlService.HOMEURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.HOMEURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.homeService(loader));
				
			});
			
		}
	}
	
	errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
	}
	
	homeService=function(loade){
		//console.log(" Home Receive jsondata ==>"+JSON.stringify(this.jsonDt.categorydata));
		//console.log("namedata ==>"+JSON.stringify(this.jsonDt.userdata));
		////console.log("category dt =====>"+this.userDt[0].name);
		var session_ids=window.localStorage.getItem('session_ids');
		var userid = window.localStorage.getItem('userid');
		this.kilopointdataDt = this.jsonDt.kilopointdata;
		this.balances = this.kilopointdataDt[0].balance;
		var kiloSabjiJSONdata = JSON.stringify({"usediscount":this.showDiscount,"userid":userid,"IMEI":session_ids,"deliverytype":window.localStorage.getItem('selectDeliveryType')});
		//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
		loade.dismiss();
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.MYCARTCHECKOUTCAll ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.SendDataOnServer(loader));
		});
		
		if(parseInt(this.useddiscount) < parseInt(this.balances)){
			this.dispoint= this.useddiscount;	
		}
		
		//if(this.balances < this.useddiscount)
		else{
			this.dispoint= this.balances;	
		}
		window.localStorage.setItem('dispoint',this.dispoint);
	}
	
	SendDataOnServer=function(loader){
		loader.dismiss();
		this.sendContinueData=null;
		//console.log("aaaaaaa======>"+JSON.stringify(this.jsonDt));
		var sendData=null;
		this.addtocartDt = this.jsonDt.addtocartdata;
		
		this.totalAmountDt = this.jsonDt.totalAmount;
		this.discountAmountDt = this.jsonDt.discountAmount;
		this.deliverydatedataDt = this.jsonDt.deliverydatedata;
		this.chargTaxDt = this.jsonDt.maxgst[0].gst;
		this.minOrderValue = this.jsonDt.orderconfig[0].minOrderValue;
		this.cashondelivery = this.jsonDt.orderconfig[0].cashondelivery;
		this.takeawayDiscount = this.jsonDt.orderconfig[0].takeawayDiscount;
		this.referFriendPoint = this.jsonDt.orderconfig[0].referFriendPoint;
        this.signupPoint = this.jsonDt.orderconfig[0].signupPoint;
		this.billamt = this.jsonDt.addtocartdata[0].billamt;
		//alert("chargTaxDt===>"+this.chargTaxDt);
		this.deliveryCharge = window.localStorage.getItem('deliveryCharge');
		
		this.deliveryGST =(this.chargTaxDt/100)*this.deliveryCharge;
		
		this.totalBillamt=parseFloat(this.billamt)+parseFloat(this.deliveryCharge)+parseFloat(this.deliveryGST);
		
		//alert("gst"+this.deliveryGST+ "   " +this.deliveryCharge+"     "+this.billamt+"    "+this.totalBillamt);
		//if(this.addtocartDt.length>0){
		//		this.cartid = this.addtocartDt[0].cartid;}
		//	this.amount = this.totalAmountDt[0].amount;
		//this.noofitem = this.addtocartDt.length;
		//this.totalSendAmt = this.totalAmountDt[0].amount;addtocartdetail
		this.sendTotalAmount = 0.0;
		this.sendDiscount = 0.0;
		this.sendTaxableamt = 0.0;
		this.sendSGSTtaxamt = 0.0;
		this.sendBillamt = 0.0;
		this.sendGSTAmt = 0.0;
		this.CGSTtaxamt  = 0.0;
		this.addtocartDetailDt = this.jsonDt.addtocartdetail;
		//alert(JSON.stringify(this.addtocartDt));
		for(var i=0;i<this.addtocartDt.length;i++){
			this.cartid = this.addtocartDt[i].cartid;
			//alert(this.addtocartDt[i].totalAmount);
			this.sendTotalAmount =this.sendTotalAmount+parseFloat(this.addtocartDt[i].totalAmount);
			this.sendDiscount =this.sendDiscount+parseFloat(this.addtocartDt[i].discount);
			this.sendTaxableamt =this.sendTaxableamt+parseFloat(this.addtocartDt[i].taxableamt);
			this.sendSGSTtaxamt =this.sendSGSTtaxamt+parseFloat(this.addtocartDt[i].SGSTtaxamt);
			this.CGSTtaxamt =this.CGSTtaxamt+parseFloat(this.addtocartDt[i].CGSTtaxamt);
			this.sendBillamt =this.sendBillamt+parseFloat(this.addtocartDt[i].billamt);
			//alert("alert  this.sendGSTAmt ===>"+this.sendGSTAmt);
			this.sendGSTAmt = this.sendGSTAmt+parseFloat(this.addtocartDt[i].SGSTtaxamt)+parseFloat(this.addtocartDt[i].CGSTtaxamt)
			//alert("alert  this.sendGSTAmt ===>"+this.sendGSTAmt);
			//	alert("aaaaaaaaaaaaaaaaaaaaaaa===>"+this.sendGSTAmt+"              "+this.CGSTtaxamt+"             "+this.sendBillamt+"             "+this.sendSGSTtaxamt+"             "+this.sendDiscount+"             "+this.sendDiscount+"             "+this.sendTotalAmount);
			////console.log("aaaaaaaaaaaaaaaaaaaaaaa===>"+this.sendGSTAmt+"              "+this.CGSTtaxamt+"             "+this.sendBillamt+"             "+this.sendSGSTtaxamt+"             "+this.sendDiscount+"             "+this.sendDiscount+"             "+this.sendTotalAmount);
			var dataArray=null;
			////console.log("aaaaaaaaaasdfssssfffffloop===>"+this.cartid+"<=================>"+this.addtocartDetailDt[i].addtocartId);
			if(this.addtocartDetailDt.length>0){
				for(var j=0;j<this.addtocartDetailDt.length;j++){
					////console.log(j+"<======aaffloop===>"+this.cartid+"<=================>"+this.addtocartDetailDt[j].addtocartId);
					
					if(this.cartid == this.addtocartDetailDt[j].addtocartId){
						////console.log("aaaaaaaaaaaa=out==>"+dataArray+j)
						if(dataArray==null){
							//	//console.log("aaaaaaaaaaaa=In==>"+dataArray+j)
							dataArray = JSON.stringify(this.addtocartDetailDt[j]);
							
							//			//console.log("jdakjklsjglkjsljk-this.addtocartDetailDt[j]===>====>"+this.addtocartDetailDt[j]+" dataArray==>hhhhhhhhhhhhhhhhhh==========>"+dataArray);
							}else{
							//				//console.log("aaaaaaaaaaaa=else==>"+dataArray+j)
							dataArray = JSON.stringify(this.addtocartDetailDt[j])+","+dataArray;
						}
						//	//console.log("ssssssssssss==this.addtocartDt[i])+JSON.stringify(this.addtocartDetailDt[j]=>"+JSON.stringify(this.addtocartDt[i])+JSON.stringify(this.addtocartDetailDt[j]));
						
						}else{
						if(dataArray==null){
							dataArray =JSON.stringify({"addtocartI":'',"productId":'',"categoryid":''});
						}}
				}}else
				{	dataArray =JSON.stringify({"addtocartId":'',"productId":'',"categoryid":''});
				}
				dataArray = "["+dataArray+"]";
				//		//console.log("ffffffffffffffffffffffffffffffffffffff===>"+dataArray);
				//"discount":"8","taxableamt":"92.00","SGSTtaxamt":"5.52","CGSTtaxamt":"5.52","billamt":"103.04"
				if(this.addtocartDt[i].type=="addon"){
					//alert(parseFloat(this.addtocartDt[i].addonPerson)*parseFloat(this.addtocartDt[i].orderqty));
					var kiloSabjiJSONdata = JSON.stringify({"persons":parseFloat(this.addtocartDt[i].addonPerson)*parseFloat(this.addtocartDt[i].orderqty),"sizePerPack":this.addtocartDt[i].sizePerPack,"categoryname":this.addtocartDt[i].categoryname,"productName":this.addtocartDt[i].productName,"type":this.addtocartDt[i].type,"qty":this.addtocartDt[i].qty,"price":this.addtocartDt[i].price,"totalAmount":this.addtocartDt[i].totalAmount,"productId":this.addtocartDt[i].productId,"categoryid":this.addtocartDt[i].categoryid,"uom":this.addtocartDt[i].uom,"uomid":this.addtocartDt[i].uomid,"cartid":this.addtocartDt[i].cartid,"orderqty":this.addtocartDt[i].orderqty,"qtyPerPack":this.addtocartDt[i].qtyPerPack,"qtys":this.addtocartDt[i].qtys,"balqty":this.addtocartDt[i].balqty,"taxableamt":this.addtocartDt[i].taxableamt,"SGSTtaxamt":this.addtocartDt[i].SGSTtaxamt,"CGSTtaxamt":this.addtocartDt[i].CGSTtaxamt,"billamt":this.addtocartDt[i].billamt,"discount":this.addtocartDt[i].discount,"kilopartyorder":JSON.parse(dataArray)});
					}else{
					var kiloSabjiJSONdata = JSON.stringify({"persons":this.addtocartDt[i].minimumOrder,"categoryname":this.addtocartDt[i].categoryname,"sizePerPack":this.addtocartDt[i].sizePerPack,"productName":this.addtocartDt[i].productName,"type":this.addtocartDt[i].type,"qty":this.addtocartDt[i].qty,"price":this.addtocartDt[i].price,"totalAmount":this.addtocartDt[i].totalAmount,"productId":this.addtocartDt[i].productId,"categoryid":this.addtocartDt[i].categoryid,"uom":this.addtocartDt[i].uom,"uomid":this.addtocartDt[i].uomid,"cartid":this.addtocartDt[i].cartid,"orderqty":this.addtocartDt[i].orderqty,"qtyPerPack":this.addtocartDt[i].qtyPerPack,"qtys":this.addtocartDt[i].qtys,"balqty":this.addtocartDt[i].balqty,"taxableamt":this.addtocartDt[i].taxableamt,"SGSTtaxamt":this.addtocartDt[i].SGSTtaxamt,"CGSTtaxamt":this.addtocartDt[i].CGSTtaxamt,"billamt":this.addtocartDt[i].billamt,"discount":this.addtocartDt[i].discount,"kilopartyorder":JSON.parse(dataArray)});
				}
				dataArray=null;
				if(this.sendContinueData ==null){
					this.sendContinueData = kiloSabjiJSONdata;
					//alert('if=========>>'+this.sendContinueData);
					}else{
					this.sendContinueData =kiloSabjiJSONdata+","+this.sendContinueData;
					//alert('else=========>>'+this.sendContinueData);
				}
		}
		//alert("amttax gross"+this.sendTaxableamt);
		this.sendTaxableamt=parseFloat(this.sendTaxableamt)+parseFloat(this.deliveryCharge);
		this.sendGSTAmt=this.sendGSTAmt + this.deliveryGST;
		//alert("this.sendBillamt===>"+this.sendBillamt);
		this.sendBillamt=parseFloat(this.sendBillamt)+parseFloat(this.deliveryCharge)+parseFloat(this.deliveryGST);
		//alert("after this.sendBillamt===>"+this.sendBillamt);
		this.sendBillamt = Math.round( this.sendBillamt );
		//this.sendBillamt=parseFloat(this.sendBillamt)+parseFloat(this.deliveryCharge);
		//alert("amttax gross"+this.sendTaxableamt);
		this.sendContinueData = "["+this.sendContinueData+"]";
		////console.log("aaaaaaaaaaaa======>send Json Data To Server===>"+this.sendContinueData);		
		
		
	}
	
	checkBox(checkval){
		this.checkvalue= checkval;
	}
	
	showTC(){
		this.payTmErrorAlert("<ul><b><u>Terms and conditions</u></b></ul><ul><li>By using our Website/ Mobile app,you agree to comply with and be bound by the following terms and conditions of use, which together with our privacy policy govern Kilosubzi.com’s relationship with you, in relation to this website/ mobile app.</li><li>The term ‘’ Kilosubzi.com’’ or ‘’ us ‘’ or ‘’we’’ or  “our’’ refers to the owner of the website/ mobile app , Advent Greens pvt ltd , whose registered office is situated at R-2, Tilak Marg , C-Scheme , Jaipur . Pincode 302005.<li>Our PAN No is AABCA5215D</li><li>Our GSTRegn No is 08AABCA5215D1Z8<li> The term ‘’you’’ or ‘’your’’ refers to the user/customer/viewer of our website/ mobile app.</li><h6>The use of this Website/ Mobile app is subject to the following terms of use </h6><li>The content of the pages of this website/ mobile app is for your general information and use only. It is subject to change without notice.</li><li>Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website/ mobile app for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.</li><li>Your use of any information or materials on this website/ mobile app is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website/ mobile app meet your specific requirements.</li><li>This website/ mobile app contains material which includes,but is not limited to, the design, layout, look, appearance and graphics.Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.</li><li>Unauthorized use of this website/ mobile app may give rise to a claim for damages and/or be a criminal offence.</li><li>You may not create a link to this website/ mobile app from another website/mobile app or document without kilosubzi.com prior written consent.</li><li>Your use of this website/ mobile app and any dispute arising out of such use of the website/ mobile app is subject to the laws of India or other regulatory authority.</li><h6>Order/Delivery</h6><li>Rates are subject to change without any prior notice.</li><li>Seasonal products available during the season only.</li><li>Price mentioned in the Website/ Mobile App is exclusive of GST and delivery charge.</li><li>Order (Above the value as specified on the Website/ Mobile app for cash on delivery) will be confirmed only after full payment towards the same has been received by Kilosubzi.com.</li><li>The facility of Cash on delivery (For orders up to net bill value as specified in the Website/ Mobile app) is at the sole discretion of Kilosubzi.com.</li><li>Minimum cart order for Home Delivery is Gross Value as specified in the Website/ Mobile app, and is subject to change at any time without prior notice at the sole discretion of Kilosubzi.com</li><li> Delivery Charges shall be levied per order as specified in the Website / Mobile App which may be subject to change from time to time </li><li>Delivery shall be made within a radius of 10 Kms from Bapu Nagar or the municipal limits of Jaipur city whichever is near.</li><li>Delivery shall be made within the time limit stipulated for the relevant order in the Website/ Mobile App, however any delay may be there due to unforeseen circumstances beyond our control.</li><li>In case of delay in delivery for more than two hours beyond the stipulated time, the order shall deem to be cancelled and refund will be given to the buyer.</li><li>Kilosubzi.com will not be responsible for delay / non delivery due to improper / incomplete address given by the buyer and in such a situation the order shall deem to be cancelled and no refund shall be given.</li><li>Delivery shall be made in disposable containers and the customer may reheat the food only in microwave friendly containers before consumption.</li><li>Food has to be consumed within Three hours from the time of delivery. In no situation the food should be stored overnight.</li><li>The product images in the Website/ Mobile app are for illustration purpose only. The actual product may vary.</li><li>By purchasing our product the customers hereby agree that the products sold by us are intended to be used by them or their family/friends/guests for immediate consumption and are not meant for resale to anyone.</li><h6>Kilo Points</h6><li>Kilosubzi.com reserves its right to alter / withdraw / extend any offer / promotion of Kilo point scheme at any time without giving any prior notice and without assigning any reason whatsoever.</li><li>All disputes related to any offer/ promotions will be subject to exclusive jurisdiction of court of Jaipur only.</li><li>All customers who sign up through our Mobile App / Website will be referred as Kilo Loyale.</li><li> "+this.signupPoint +" Kilo points will be awarded on sign up through Mobile app.  These points can be used immediately upon sign up.</li><li>Every Kilo Loyale will get a referral code. When he refers the app to his phone book contacts and the contact signs up using this code, then the referring Kilo Loyale will get "+this.referFriendPoint +" referral points.</li><li>The referral points can be used immediately after credit.</li><li>Kilo Points accumulated by a Kilo Loyale on his purchase will become active after 2 Hrs, for usage as discount.</li><li>Kilo points are valid for three calendar months after the month in which they are accumulated.</li><li>Kilo points can be redeemed towards discounts on every purchase subject to a limit prescribed as under (All Redemptions before tax).</li><li>Kilo Menu order: Redemption discount 8 % of gross order value.</li><li>Kilo Menu Take away: Additional redemption discount "+this.takeawayDiscount+"% of gross order value.</li><li>Kilo Menu purchase: Kilo point accumulation 15 % of gross order value.</li><li>Kilo Party order: Redemption discount 5 % of gross order value.</li><li>Kilo Party Take away: Additional redemption discount "+this.takeawayDiscount+"% of gross order value.</li><li>Kilo Party purchase: Kilo point accumulation 10 % of gross order value.</li><li>Kilo Store: No Redemption discount.</li><li>Kilo Store purchase: Kilo point accumulation 5% of gross order value.</li><li>The policy of awarding fresh Kilo points and its subsequent utilisation towards discount, is subject to change without prior notice at the sole discretion of Kilosubzi.com.</li><h6>Refund and Cancellation Policy:</h6><li>Order once received along with payment/ Cash on Delivery facility cannot be cancelled / modified.</li><li>In Exceptional cases the customer may request for consideration of Cancellation / modification of the order given by calling the customer care representative. Such order may be cancelled/ modified at the discretion of Kilosubzi.com.</li><li>In situation of cancellation, cancellation fees of 30 % plus GST of the net order value shall be deducted and the balance will be refunded within 10 days from the date of cancellation.</li></ul>");
	}
	
	checkout(){
		
		var givenpoint = window.localStorage.getItem('givenpoint');
		//	var multiple =window.localStorage.getItem('multiple')
		//	//console.log('multidata--->'+multiple);
		//alert(givenpoint);
		var name = window.localStorage.getItem('name');
		////console.log("name-->"+name);
		
		var address = window.localStorage.getItem('address');
		//console.log("address-->"+address);
		
		var pincode = window.localStorage.getItem('pincode');
		//console.log("pincode-->"+pincode);
		var city = window.localStorage.getItem('city');
		//console.log("city-->"+city);
		var userid=window.localStorage.getItem('userid');
		//console.log("userid-->"+userid);
		var mobileno=window.localStorage.getItem('mobileno');
		//console.log("mobileno-->"+mobileno);
		var items =window.localStorage.getItem('noofitem');
		//console.log("items--->"+items);
		//var deliverytype=window.localStorage.getItem('delivery');
		var dispoints =window.localStorage.getItem('dispoint');
		var delDate =window.localStorage.getItem('delDate');
		var delTime =window.localStorage.getItem('delTime');
		var deliverySelectItem  = window.localStorage.getItem('selectItem');
		var dispoints =window.localStorage.getItem('dispoint');
		
		var givenpoint = window.localStorage.getItem('givenpoint');
		var deliveryarea=window.localStorage.getItem('selectArea');
		//alert("selectArea===>"+deliveryarea);
		var deliverycharge = window.localStorage.getItem('deliveryCharge')
		var paymentMode=null;	
		if(window.localStorage.getItem('payMethod')=='Cash On Delivery'){
			paymentMode = "Cash On Delivery";
			}else {
			paymentMode="Online Through Website";
		}
		
		
		if(window.localStorage.getItem('payMethod')=='Cash On Delivery'){
			if(this.sendBillamt<=this.cashondelivery  && 	parseInt(this.sendBillamt)>parseInt(window.localStorage.getItem('deliveryAmountVali'))){
				var deliveryarea=window.localStorage.getItem('selectArea');
				//alert("area--->d+"+deliveryarea)
				var deliverycharge = window.localStorage.getItem('deliveryCharge')
				
				var kiloSabjiJSONdata = JSON.stringify({"paymentMode":'Cash On Delivery',"deliveryarea":deliveryarea,"deliverycharge":deliverycharge,"deliverygst":this.chargTaxDt,"userid":userid,"totalAmount":this.sendBillamt,"noofitem":items,"deliverdate":delDate,"delivertime":delTime,"name":name,"mobileno":mobileno,"pincode":'',"address":address,"city":city,"discountAmount":this.sendDiscount,"givenpoint":givenpoint,"deliveryType":deliverySelectItem,"multidata":JSON.parse(this.sendContinueData)});
				//alert(this.checkvalue);
				if(this.checkvalue==true){
					//console.log("Product Url--->"+this.myurlService.BOOKINGURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
					//let loader = this.loading.create({content: '',});
					this.sendJsonData=JSON.stringify({"paymentMode":'Cash On Delivery',"deliveryarea":deliveryarea,"deliverycharge":deliverycharge,"deliverygst":this.chargTaxDt,"userid":userid,"totalAmount":this.sendBillamt,"noofitem":items,"deliverdate":delDate,"delivertime":delTime,"name":name,"mobileno":mobileno,"pincode":'',"address":address,"city":city,"discountAmount":this.sendDiscount,"givenpoint":givenpoint,"deliveryType":deliverySelectItem,"multidata":JSON.parse(this.sendContinueData)});
					//alert("Booking Url--->"+this.myurlService.BOOKINGURL+"       "+kiloSabjiJSONdata);
							this.typeofCalling="withoutPaytm";
					this.checkProductAvail();
					
					//loader.present().then(() => {
						//this.mydataService.postJSON(this.myurlService.BOOKINGURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.bookingService(loader));
				//});
					}else{
					this.payTmErrorAlert('Please accept terms and conditions');
				}
				}else{
				this.payTmErrorAlert('Bill amount must be less then Rs. '+ this.cashondelivery+' and grater then Rs. '+ this.minOrderValue +' for COD ');
			}
			}else{
			
			if(this.checkvalue==true){
				if(this.sendBillamt<=window.localStorage.getItem('deliveryAmountVali')){
					this.payTmErrorAlert("Please make sure your order amount more then Rs. "+window.localStorage.getItem('deliveryAmountVali'));
					}else{
					//let loader = this.loading.create({content: '',});
					var callPayTm = JSON.stringify({"amount":this.sendBillamt,"webtype":'website',"paymentMode":paymentMode,"deliveryarea":deliveryarea,"deliverycharge":deliverycharge,"deliverygst":this.chargTaxDt,"userid":userid,"totalAmount":this.sendBillamt,"noofitem":items,"deliverdate":delDate,"delivertime":delTime,"name":name,"mobileno":mobileno,"pincode":'',"address":address,"city":city,"discountAmount":this.sendDiscount,"givenpoint":givenpoint,"deliveryType":deliverySelectItem,"multidata":JSON.parse(this.sendContinueData)});
					
					this.sendJsonData=JSON.stringify({"amount":this.sendBillamt,"webtype":'website',"paymentMode":paymentMode,"deliveryarea":deliveryarea,"deliverycharge":deliverycharge,"deliverygst":this.chargTaxDt,"userid":userid,"totalAmount":this.sendBillamt,"noofitem":items,"deliverdate":delDate,"delivertime":delTime,"name":name,"mobileno":mobileno,"pincode":'',"address":address,"city":city,"discountAmount":this.sendDiscount,"givenpoint":givenpoint,"deliveryType":deliverySelectItem,"multidata":JSON.parse(this.sendContinueData)});
					this.typeofCalling="withPaytm";
					this.checkProductAvail();
					//loader.present().then(() => {
						//this.mydataService.postJSON(this.myurlService.PAYTMURL ,callPayTm).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.goPayTmPage(loader));
				//});		
				}
				}else{
				this.payTmErrorAlert('Please accept terms and conditions.');
				
			}}
	}
	checkProductAvail=function(){
		var kiloSabjiJSONdata = JSON.stringify({"deliverydate":window.localStorage.getItem('delDate'),"userid":window.localStorage.getItem('userid'),"IMEI":window.localStorage.getItem('session_ids')});
			//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.CHECKPRODUCTEXIST ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.AvailProduct(loader));
			});
		}
		
		AvailProduct=function(load){
				load.dismiss();
				//alert("chekk===>"+this.typeofCalling)
				//alert("chekk msg===>"+this.sendJsonData)
				//alert("chekk===>"+JSON.stringify(this.jsonDt))
				let loa = this.loading.create({content: '',});
				if(this.jsonDt.msg==""){
				if(this.typeofCalling=="withoutPaytm"){
					loa.present().then(() => {
						this.mydataService.postJSON(this.myurlService.BOOKINGURL ,this.sendJsonData).subscribe(data => this.jsonDt= data,error => this.errorFunction(loa,error),() =>this.bookingService(loa));
					});
					}else{
					loa.present().then(() => {
						this.mydataService.postJSON(this.myurlService.PAYTMURL ,this.sendJsonData).subscribe(data => this.jsonDt= data,error => this.errorFunction(loa,error),() =>this.goPayTmPage(loa));
					});
					}
					}else{
						this.payTmErrorAlert(this.jsonDt.msg);
					}
		}
	
	goPayTmPage = function(loader){	
		loader.dismiss();
		this.generatChecksum = this.jsonDt.generateChecksum;
		this.order_id=this.generatChecksum[0].order_id;
		this.checkSum=this.generatChecksum[0].checkSum;
		var userid=window.localStorage.getItem('userid');
		var mobileno=window.localStorage.getItem('mobileno');
		//alert(this.order_id);
		//console.log("paytm respose===>"+JSON.stringify(this.jsonDt.generateChecksum)+"              "+this.checkSum+"              " +this.order_id);
		//let load = this.loading.create({content: '',});
		/*	
			var callPayT = JSON.stringify({"TXNID":"","BANKTXNID":"12585555555","ORDERID":this.order_id,"TXNAMOUNT":this.sendBillamt,"STATUS":"","TXNTYPE":"","CURRENCY":"","GATEWAYNAME":"","RESPCODE":"","RESPMSG":"","BANKNAME":"ICICI BAnk","MID":"","PAYMENTMODE":"CASH","REFUNDAMT":"","TXNDATE":"","IS_CHECKSUM_VALID":"","CHECKSUMSENT":this.checkSum,"CHECKSUMRECEIVED":"","MOBILE_NO":"9024061407","Token":""});
			//loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.PAYTMPMtCOMPLET ,callPayT).subscribe(data => this.jsonDt= data,error => //console.log(error),() =>this.payTmComplete());
			//		});	
		*/
		
		// alert("order_id===>"+this.order_id+"   userid===>  "+userid+"    email===>"+"    mobileno===>"+mobileno+"    sendBillamt===>"+this.sendBillamt+"    staging");
		//this.paytm.startPayment(this.order_id, userid, this.checkSum ,mobileno, this.sendBillamt, "staging")
		// .then((res: any) => //console.log(res))
		//.then((res: any) => this.payTmResponse(res))
		//.catch((error: any) => this.payTmResponse(error));
		//http://localhost/PaytmKit/TxnTest.php
		this.siteurl= this.myurlService.KILOSABJIURL;
		//alert(this.siteurl);
		window.location.href='http://kilosubzi.com/PaytmKit/TxnTest.php?orderid='+this.order_id+'&custid='+userid+'&amount='+this.sendBillamt;
		var encodedString = 'ORDER_ID=' +
		encodeURIComponent(this.order_id) +
	'&CUST_ID=' +
	encodeURIComponent(userid) +
	'&INDUSTRY_TYPE_ID=' +
	encodeURIComponent('Retail') +
	'&CHANNEL_ID=' +
	encodeURIComponent('WAP') +
	'&TXN_AMOUNT=' +
	encodeURIComponent(this.sendBillamt) +
	'&MID=' +
	encodeURIComponent('Advent14325032475060') +
	'&WEBSITE=' +
	encodeURIComponent('APP_STAGING');	
	
	//alert(JSON.stringify(encodedString));
	
	
	
	/*		//alert(userid);
	var kiloSabjiJSONdata = JSON.stringify({"userid":userid});
	//console.log("Home Url--->"+this.myurlService.PAYTMPAGE+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	let loaderss = this.loading.create({content: '',});
	loaderss.present().then(() => {
	this.mydataService.postJSON(this.myurlService.PAYTMPAGE ,encodedString).subscribe(data => this.jsonDt= data,error => this.errorFunction(loaderss,error),() =>this.paytmService(loaderss,this.order_id,userid,this.sendBillamt));
	
	});
	*/	
	
	
	
	}	
	/* paytmService = function(loaderss,orderid,userid,amount){	
	loaderss.dismiss();
	alert('asdasdfasf');
	this.getChecksum = this.jsonDt.getChecksum;
	//console.log("aaaaaaa======>"+JSON.stringify(this.jsonDt));
	alert(JSON.stringify(this.getChecksum));
	this.PAYTM_TXN_URL=this.getChecksum[0].PAYTM_TXN_URL;
	this.checkSum=this.getChecksum[0].checkSum;
	alert(this.PAYTM_TXN_URL);
	//var userid = window.localStorage.getItem('userid');
	var encodedString = 
	'MID=' +
	encodeURIComponent('Advent14325032475060') +
	'&ORDER_ID=' +
	encodeURIComponent(orderid) +
	'&CUST_ID=' +
	encodeURIComponent(userid) +
	'&INDUSTRY_TYPE_ID=' +
	encodeURIComponent('Retail') +
	'&CHANNEL_ID=' +
	encodeURIComponent('WAP') +
	'&TXN_AMOUNT=' +
	encodeURIComponent(amount) +
	'&WEBSITE=' +
	encodeURIComponent('APP_STAGING')	+
	'&CHECKSUMHASH=' +
	encodeURIComponent(this.checkSum);
	
	alert(JSON.stringify(encodedString));
	//alert(userid);
	var kiloSabjiJSONdata = JSON.stringify({"userid":userid});
	////console.log("Home Url--->"+this.myurlService.PAYTMPAGE+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	//let loadersss = this.loading.create({content: '',});
	//loadersss.present().then(() => {
	this.mydataService.postJSON(this.PAYTM_TXN_URL ,encodedString);
	
	//});
	
	}*/
	//paytmServicess = function(loadersss){
	//	loadersss.dismiss();
	//}
	payTmResponse = function(res){	
	//alert("response===>"+res)
	var obj = JSON.parse(res);
	////console.log("aaaaaaa======>"+JSON.stringify(this.jsonDt));
	this.STATUS=obj.STATUS;
	this.CHECKSUMHASH=obj.CHECKSUMHASH;
	var mobileno=window.localStorage.getItem('mobileno');
	if(this.STATUS=="TXN_SUCCESS"){
	let load = this.loading.create({content: '',});
	//obj.CHECKSUMHASH
	var callPayT = JSON.stringify({"TXNID":obj.TXNID,"BANKTXNID":obj.BANKTXNID,"ORDERID":obj.ORDERID,"TXNAMOUNT":this.sendBillamt,"STATUS":obj.STATUS,"TXNTYPE":"","CURRENCY":obj.CURRENCY,"GATEWAYNAME":obj.GATEWAYNAME,"RESPCODE":obj.RESPCODE,"RESPMSG":obj.RESPMSG,"BANKNAME":obj.BANKNAME,"MID":"","PAYMENTMODE":"CASH","REFUNDAMT":"","TXNDATE":"","IS_CHECKSUM_VALID":"","CHECKSUMSENT":this.checkSum,"CHECKSUMRECEIVED":"","MOBILE_NO":mobileno,"Token":""});
	//alert("Ahmad===>"+callPayT);
	load.present().then(() => {
	this.mydataService.postJSON(this.myurlService.PAYTMPMtCOMPLET ,callPayT).subscribe(data => this.jsonDt= data,error => this.errorFunction(load,error),() =>this.payTmComplete(load));
	});	
	}else{
	this.payTmErrorAlert('Transition failed please try again later');
	}
	
	}
	checkKiloPoint(kiloPointStatus){
	//alert(kiloPointStatus);
	if(kiloPointStatus==true){
	//alert(kiloPointStatus+"1");
	this.showDiscount='1';
	this.kiloPointCheck();
	
	}else{
	this.showDiscount='0';
	this.kiloPointCheck();
	//alert(kiloPointStatus+"0");
	}
	}
	
	kiloPointCheck=function(){
	var userid = window.localStorage.getItem('userid');
	var kiloSabjiJSONdata = JSON.stringify({"usediscount":this.showDiscount,"userid":userid,"IMEI":window.localStorage.getItem('session_ids'),"deliverytype":window.localStorage.getItem('selectDeliveryType')});
	//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
	
	let loader = this.loading.create({content: '',});
	loader.present().then(() => {
	this.mydataService.postJSON(this.myurlService.MYCARTCHECKOUTCAll ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.SendDataOnServer(loader));
	});
	}
	payTmComplete=function(load){
	load.dismiss();
	//alert("paytm Complete respose===>"+JSON.stringify(this.jsonDt));
	//console.log("paytm Complete respose===>"+JSON.stringify(this.jsonDt));
	this.resu=this.jsonDt.results;
	//alert("result"+this.resu);
	//if(this.results=="success"){
	var pincode = window.localStorage.getItem('pincode');
	var dispoints =window.localStorage.getItem('dispoint');
	var deliverySelectItem  = window.localStorage.getItem('selectItem');
	var givenpoint = window.localStorage.getItem('givenpoint');
	var userid=window.localStorage.getItem('userid');
	var items =window.localStorage.getItem('noofitem');
	var delDate =window.localStorage.getItem('delDate');
	var delTime =window.localStorage.getItem('delTime');
	var mobileno=window.localStorage.getItem('mobileno');
	var city = window.localStorage.getItem('city');
	var address = window.localStorage.getItem('address');
	var name = window.localStorage.getItem('name');
	var deliveryarea=window.localStorage.getItem('selectArea');
	//alert("selectArea===>"+deliveryarea);
	var deliverycharge = window.localStorage.getItem('deliveryCharge')
	var paymentMode=null;	
	if(window.localStorage.getItem('payMethod')=='Cash On Delivery'){
	paymentMode = "Cash On Delivery";
	}else {
	paymentMode="Online through Mobile App";
	}
	var kiloSabjiJSONdata = JSON.stringify({"paymentMode":paymentMode,"deliveryarea":deliveryarea,"deliverycharge":deliverycharge,"deliverygst":this.chargTaxDt,"userid":userid,"totalAmount":this.sendBillamt,"noofitem":items,"deliverdate":delDate,"delivertime":delTime,"name":name,"mobileno":mobileno,"pincode":'',"address":address,"city":city,"discountAmount":this.sendDiscount,"givenpoint":givenpoint,"deliveryType":deliverySelectItem,"multidata":JSON.parse(this.sendContinueData)});
	//alert(kiloSabjiJSONdata);
	
	//console.log("Product Url--->"+this.myurlService.BOOKINGURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	let loader = this.loading.create({content: '',});
	//alert("Booking Url--->"+this.myurlService.BOOKINGURL+"       "+kiloSabjiJSONdata);
	loader.present().then(() => {
	this.mydataService.postJSON(this.myurlService.BOOKINGURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.bookingService(loader));
	});
	}
	
	bookingService=function(loader){
	//console.log("bookingDt receive aaaaaaa jsondata ==>"+JSON.stringify(this.jsonDt));
	//	alert("bookingDt receive aaaaaaa jsondata Url--->"+JSON.stringify(this.jsonDt));
	var userid=window.localStorage.getItem('userid');
	this.bookingDt = this.jsonDt.msg;
	this.bookingTimeDt = this.jsonDt.deliverTime;
	var paymentMode = null;
	
	
	var kiloSabjiJSONdata = JSON.stringify({"userid":userid,"type":"orderbook","deliverTime":this.bookingTimeDt});
	this.mydataService.postJSON(this.myurlService.SENDOTP ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => console.log(''),() =>this.sendotps());
	
	//alert(this.amount);
	//this.subcategorydataDt= this.jsonDt.subcategorydata;
	//this.image= this.myurlService.IMAGEURL;
	
	//console.log("bookingDt ==>"+JSON.stringify(this.jsonDt.msg));
	loader.dismiss();
	//this.navCtrl.push(OrderHistoryPage);
	this.showAlert();
	}
	
	paymentMethod(payMethod){
	//alert("work--->"+payMethod);
	this.payMethod = payMethod;
	window.localStorage.setItem('payMethod',this.payMethod);
	}
	
	showAlert=function() {
	let alert = this.alerCtrl.create({
	// title: 'New Friend!',
	subTitle: "Your order booked successfully",
	buttons: [ {
	text: 'Ok',
	handler: data => {
	this.navCtrl.push(HomePage);			
	}
	}
	]
	});
	alert.present();
	}
	
	payTmErrorAlert=function(error) {
	let alert = this.alerCtrl.create({
	// title: 'New Friend!',
	subTitle: error,
	buttons: ['OK']
	});
	alert.present();
	}
	read(){
	//alert("hello");
	}
	}
		


// WEBPACK FOOTER //
// ./src/pages/payment/payment.ts